module.exports = __webpack_public_path__ + "static/mammografie.7c2af007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/header/mammografie.jpg
// module id = 461
// module chunks = 270829257937027